import {useMutation} from '@tanstack/react-query';
import shopifyUpdaters from '@/api/updaters/shopify';

const useAuthenticateShopify = () => {
  return useMutation({
    mutationKey: ['shopify', 'authenticate'],
    mutationFn: shopifyUpdaters.authenticate,
    onSuccess: (response) => {
      const redirectUrl = (response?.data as any)?.redirect_url;
      if (redirectUrl) {
        window.location.href = redirectUrl;
      }
    },
  });
};

export default useAuthenticateShopify;
